import { render, staticRenderFns } from "./PlayerBadgeShop.vue?vue&type=template&id=aa1aaa1c&scoped=true&"
import script from "./PlayerBadgeShop.vue?vue&type=script&lang=js&"
export * from "./PlayerBadgeShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1aaa1c",
  null
  
)

export default component.exports